<template>
  <div class="upsi-person-strip" data-testid="upsi-person-strip">
    <FcUserAvatar :name="name" data-test-id="upsi-person-strip__avatar" />
    <div class="upsi-person-strip__copy">
      <p class="upsi-person-strip__name">{{ name }}</p>
      <p class="upsi-person-strip__meta">{{ requestedLine }}</p>
    </div>
  </div>
</template>

<script>
import './UpsiPersonStrip.scss';
import { FcUserAvatar } from '@/modules/financialclose/components';
import { formatUtcDateTime } from '../../../../utils/helpers';

/** Requester identity: avatar, name, and when the request was raised. */
export default {
  name: 'UpsiPersonStrip',

  components: {
    FcUserAvatar,
  },

  props: {
    name: {
      type: String,
      default: '',
    },
    requestedAt: {
      type: String,
      default: '',
    },
  },

  computed: {
    requestedLine() {
      const date = formatUtcDateTime(this.requestedAt, { part: 'date' });
      const time = formatUtcDateTime(this.requestedAt, { part: 'time' });
      return `Requested ${date} · ${time}`;
    },
  },
};
</script>
